import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./MobileMenu.module.css";
import { getNavigationLabelDefaults } from "./navigationLabelDefaults";
import { useUser } from "../contexts/UserContext";

const MobileMenu: React.FC = () => {
  const { i18n, t } = useTranslation();
  const userContext = useUser();
  const userDetails = userContext?.userDetails;
  const currentLang = i18n.language;
  const labels = getNavigationLabelDefaults(currentLang);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsOpen((prev) => !prev);
  };

  const navigateTo = (path: string) => {
    setIsOpen(false);
    navigate(`/${currentLang}${path}`);
  };

  const isAdmin =
    userDetails?.id !== "Guest" &&
    typeof userDetails?.userLevel === "number" &&
    userDetails.userLevel <= 1;

  return (
    <div className={styles.mobileMenu}>
      <button className={styles.menuButton} onClick={toggleMenu} aria-label="Menu">
        Menu
      </button>
      <div className={`${styles.menuLinks} ${isOpen ? styles.open : ""}`}>
        <button onClick={() => navigateTo("/")} className={styles.submenuButton}>
          {t("navigation.home")}
        </button>
        <button onClick={() => navigateTo("/features")} className={styles.submenuButton}>
          {t("navigation.features")}
        </button>
        <button
          onClick={() => navigateTo("/sample-videos")}
          className={styles.submenuButton}
        >
          {t("navigation.sample_videos", {
            defaultValue: currentLang.toLowerCase().startsWith("ko")
              ? "예시 영상"
              : "Sample Videos",
          })}
        </button>
        <button
          onClick={() => navigateTo("/youtube-rankings")}
          className={styles.submenuButton}
        >
          {t("navigation.youtube_rankings", {
            defaultValue: currentLang.toLowerCase().startsWith("ko")
              ? "유튜브 랭킹"
              : "YouTube Rankings",
          })}
        </button>
        <button onClick={() => navigateTo("/blog")} className={styles.submenuButton}>
          {labels.blog}
        </button>
        <button onClick={() => navigateTo("/updates")} className={styles.submenuButton}>
          {labels.updates}
        </button>
        <button onClick={() => navigateTo("/pricing")} className={styles.submenuButton}>
          {t("navigation.pricing")}
        </button>
        {isAdmin && (
          <>
            <button
              onClick={() => navigateTo("/admin/members")}
              className={styles.submenuButton}
            >
              {t("admin.members", { defaultValue: "회원관리" })}
            </button>
            <button
              onClick={() => navigateTo("/admin/knowledge")}
              className={styles.submenuButton}
            >
              지식저장소
            </button>
            <button
              onClick={() => navigateTo("/admin/blog")}
              className={styles.submenuButton}
            >
              글관리
            </button>
          </>
        )}
        <button onClick={() => navigateTo("/how-to-use")} className={styles.submenuButton}>
          {t("navigation.how_to_use")}
        </button>
        <button onClick={() => navigateTo("/faq")} className={styles.submenuButton}>
          {t("navigation.faq", {
            defaultValue: labels.faq,
          })}
        </button>
        <button onClick={() => navigateTo("/support")} className={styles.submenuButton}>
          {t("navigation.support", {
            defaultValue: labels.support,
          })}
        </button>
        <button
          onClick={() => navigateTo("/support/chatbot")}
          className={styles.submenuButton}
        >
          {t("navigation.support_chatbot", {
            defaultValue: labels.supportChatbot,
          })}
        </button>
      </div>
    </div>
  );
};

export default MobileMenu;
